import React from "react";
import Homepage from "./Homepage";
import Aboutme from "./components/aboutpage/Aboutme";
import Experience from "./components/projects/Experience";
import Webapps from "./components/projects/Webapps";
import Articles from "./components/projects/Articles";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./App.css";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Homepage} />
        <Route exact path="/about" component={Aboutme} />
        <Route exact path="/webapps" component={Webapps} />
        <Route exact path="/experience" component={Experience} />
        <Route exact path="/articles" component={Articles} />
      </Switch>
    </Router>
  );
}

export default App;
